import {z} from 'zod'

export const FORGOT_PASSWORD_FORM_MODEL = {
    email: {
        name: 'email',
        label: 'login:form:email',
        placeholder: 'login:form:email',
        defaultValue: '',
        helpText: ''
    }
} as const

export const ForgotPasswordFormSchema = z.object({
    email: z.string().min(1, {message: 'errors:email'}).email({
        message: 'errors:email_valid'
    })
})

export type ForgotPasswordValidationSchema = z.infer<typeof ForgotPasswordFormSchema>
